<section class="breadcrumb-banner">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="breadcrumb-text">
          <h1>Contact </h1>
        </div>
      </div>
    </div>
  </div>
  <div class="breadcrumb-bottom-img">
    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
      alt="GHRSCF" />
  </div>
</section>
<section class="section section-sm contact section-banner-bg-1">
  <div class="container">
    <div class="row justify-content-center align-items-center mb-5">
      <div class="col-lg-4 col-md-10 col-sm-6">
        <div class="serviceBox">
          <div class="service-icon">
            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/icons/1.png" alt="GHRSCF"
              class="img-fluid">
          </div>
          <h3 class="title ">Address</h3>
          <p class="description text-center"> 345, Kingsway Shradha House, Nagpur, Nagpur,
            Maharashtra, India,
            440001
          </p>
        </div>
      </div>
      <div class="col-lg-4 col-md-10 col-sm-6">
        <div class="serviceBox">
          <div class="service-icon">
            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/icons/3.png" alt="GHRSCF"
              class="img-fluid">
          </div>
          <h3 class="title ">Phone</h3>
          <p class="description text-center"><a href="tel:7391098137 ">7391098137 </a></p>
          <!-- <p class="description text-center">0712-6617181</p> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-10 col-sm-6">
        <div class="serviceBox">
          <div class="service-icon">
            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/icons/2.png" alt="GHRSCF"
              class="img-fluid">
          </div>
          <h3 class="title ">Email</h3>
          <p class="description text-center">ghrscf.connect@raisoni.net</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <!-- <form [formGroup]="registerForm" (ngSubmit)="submitForm()" class="comments-form contact-form">
                    <div class="row gx-3">
                      <div class="col-sm-12">
                        <div class="styled-input wide form-group">
                          <input type="text" formControlName="name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                          <label>Name</label>
                          <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                            <div *ngIf="f.name.errors.required">Name is required</div>
                        </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="styled-input wide form-group">
                          <input type="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                          <label>E-mail</label>
                          <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                            <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="styled-input wide form-group">
                          <input type="text" formControlName="phone" minlength="10" maxlength="10" pattern="^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.phone.errors }">
                          <label>Phone</label>
                          <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                            <div *ngIf="f.phone.errors.required">Mobile Number is required.</div>
                            <div *ngIf="f.phone.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12">
                        <div class="styled-input wide form-group">
                          <textarea formControlName="message" class="form-control"></textarea>
                          <label>Message</label>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="form-group">
                          <button class="btn button--effect-1 w-50"><span>
                            Send</span> <span class="icon-right-arrow"></span></button>
                        </div>

                      </div>
                    </div>
                  </form>    -->
      </div>
      <div class="col-md-12">

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14884.193515836903!2d79.08144124790925!3d21.150472899839063!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf5d9517f608873d0!2sShradha+House!5e0!3m2!1sen!2sin!4v1511161694065"
          width="100%" height="400" frameborder="0" style="border:0" allowfullscreen=""></iframe>

      </div>
    </div>
  </div>
</section>
